import React, { useContext, useEffect, useState, useCallback } from 'react';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { getProductActivity } from '../../../../../store/products/products.api';
import { ProductDetailsContext } from '../../../context';
import { PAGE_SIZE_10 } from '../../../../../services/pagination-service';
import { ProductActivity } from './index';

import style from './style.module.less';

export const ProductDetailsActivity = () => {
  const { productId, activity, setActivity } = useContext(ProductDetailsContext);
  const initalPage = activity.length ? Math.floor(activity.length / PAGE_SIZE_10) + 1 : 1;
  const [page, setPage] = useState(initalPage);
  const [totalCount, setTotalCount] = useAsyncSafeState(0);
  const [isLoading, setIsLoading] = useAsyncSafeState(false);

  useEffect(() => {
    setIsLoading(true);
    getProductActivity(productId, page, PAGE_SIZE_10).then((activityResponse) => {
      setActivity((state) =>
        activityResponse.productActivities.reduce((acc, act) => {
          return { ...acc, [act.id]: act };
        }, state),
      );
      setTotalCount(activityResponse.totalCount);
      setIsLoading(false);
    });
  }, [page, productId, setActivity, setIsLoading, setTotalCount]);

  const loadNextPage = useCallback(() => setPage(page + 1), [page]);

  return (
    <div className={style.content}>
      {isLoading && activity.length <= 0 ? (
        <LoadingIndicator />
      ) : (
        <ProductActivity activity={activity} isLoading={isLoading} loadNextPage={loadNextPage} totalCount={totalCount} />
      )}
    </div>
  );
};
